import Link from "next/link";
import { Col, Image, Row } from "react-bootstrap";
import { gql, useQuery } from "@apollo/client";

import Seo from "@/components/seo";
import Loader from "@/components/common/Loader/Loader";
import { useUser } from "@/components/contexts/user";
import handleServerSideProps from "src/lib/handle-server-side-props";

export async function getServerSideProps({ params, ...context }) {
  if (!parseInt(params.id)) return { notFound: true };
  const { data, result } = await handleServerSideProps({
    context,
    pageQuery,
    variables: { id: params.id },
    props: { id: params.id },
  });
  if (!data.deejayById) return { notFound: true };

  return result;
}

function DeejayDetail({ id }) {
  const user = useUser();
  const { data } = useQuery(pageQuery, { variables: { id: Number(id) } });

  if (!data) return <Loader />;

  const deejay = data.deejayById;
  return (
    <div className="container">
      <Row>
        <Seo title={`${deejay.dj} | DJ`} />
        <Col sm={5} md={4} lg={3}>
          <Image
            className="dj-img"
            src={
              deejay.pic ? deejay.pic : "/static/main/images/defaultAvatar.jpg"
            }
            fluid
            alt={deejay.dj}
          />
        </Col>
        <Col sm={7} md={8} lg={9}>
          <h1>
            <strong>{deejay.dj}</strong>
          </h1>
          {user.isAuthenticated ? (
            <p id="dj-name-label">
              {" "}
              -{" "}
              <strong>
                <a href={`/dj/${deejay.user.id}/edit/`}>EDIT</a>
              </strong>
            </p>
          ) : null}
          <article
            className="dj-bio"
            dangerouslySetInnerHTML={{ __html: deejay.bio }}
          />
          {user.isAuthenticated ? (
            <>
              <p>
                {deejay.user.firstName} {deejay.user.lastName}
              </p>
              <p>
                Email: <i>{deejay.user.email}</i>
              </p>
              {deejay.phone ? (
                <p>
                  Phone Number: <i>{deejay.phone}</i>
                </p>
              ) : null}
            </>
          ) : null}

          <br />
          {deejay.activeShows ? (
            <>
              <h4>
                <strong>Current Shows:</strong>
              </h4>
              {deejay.activeShows.map((show) => (
                <Link key={show.id} href={"/show/" + show.id + "/"}>

                  {show.banner ? (
                    <Image
                      src={show.banner}
                      fluid
                      style={{ width: "500px" }}
                      alt={`${show.showName} banner`}
                    />
                  ) : (
                    <p>
                      {show.showName} - {show.showDate} at {show.startTime}
                    </p>
                  )}

                </Link>
              ))}
            </>
          ) : null}
          {deejay.inactiveShows ? (
            <>
              <h4>
                <strong>Inactive Shows:</strong>
              </h4>
              {deejay.inactiveShows.map((show) => (
                <Link key={show.id} href={"/show/" + show.id + "/"}>

                  {show.banner ? (
                    <Image
                      src={show.banner}
                      fluid
                      style={{ width: "500px" }}
                      alt={`${show.showName} banner`}
                    />
                  ) : (
                    <p>{show.showName}</p>
                  )}

                </Link>
              ))}
            </>
          ) : null}
        </Col>
      </Row>
    </div>
  );
}

export default DeejayDetail;

const pageQuery = gql`
  query ($id: ID!) {
    deejayById(id: $id) {
      pic
      dj
      bio
      phone
      user {
        __typename
        id
        firstName
        lastName
        email
      }
      activeShows {
        __typename
        id
        showName
        startTime
        banner
      }
      inactiveShows {
        __typename
        id
        showName
        startTime
        banner
      }
    }
  }
`;
